import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { useLocation } from "react-router-dom";
import { Button, Result } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import { TextService } from "../../Services/TextService";


const EventAnsweredComplete = () => {
  const location = useLocation();
  const name = location.state?.name;
  const acceptedTimes: string[] = location.state?.acceptedTimes ?? [];
  const waitlistedTimes: string[] = location.state?.waitlistedTimes ?? [];
  const isWaitlisted = waitlistedTimes.length > 0;
  // Only the waitlist and nothing else: the whole answer is "you are on the waitlist".
  const isOnlyWaitlisted = (location.state?.people?.length ?? 0) > 0
    ? location.state.people.every((p: any) => p.waitlistedTimes.length > 0 && p.acceptedTimes.length === 0)
    : isWaitlisted && acceptedTimes.length === 0;
  // With several times the guest needs to see which time gave what.
  const showTimes = isWaitlisted && (location.state?.hasSeveralTimes === true || acceptedTimes.length > 0);

  // When a household was signed up: what each person got.
  const people: { name: string, acceptedTimes: string[], waitlistedTimes: string[] }[] = location.state?.people ?? [];
  const hasSeveralTimes = location.state?.hasSeveralTimes === true;

  const getPersonStatus = (person: { acceptedTimes: string[], waitlistedTimes: string[] }) => {
    const parts: string[] = [];

    if (person.acceptedTimes.length > 0) {
      parts.push(GetText("EventAnswerComplete_PersonHasPlace") + (hasSeveralTimes ? " " + person.acceptedTimes.join(", ") : ""));
    }

    if (person.waitlistedTimes.length > 0) {
      parts.push(GetText("EventAnswerComplete_PersonOnWaitlist") + (hasSeveralTimes ? " " + person.waitlistedTimes.join(", ") : ""));
    }

    return parts.length > 0 ? parts.join(", ") : GetText("EventAnswerComplete_PersonSaved");
  };

  // A guest who cancelled a sign-up with only "Kommer". The organizer is told as with any answer.
  const isCancelled = location.state?.cancelled === true;

  const getSubTitle = () => {
    if (isCancelled) {
      return GetText("EventAnswerComplete_Description");
    }

    if (people.length > 0) {
      return <>
        {people.map((person, i) => <div key={i}>{person.name}: {getPersonStatus(person)}</div>)}
        {people.some(p => p.waitlistedTimes.length > 0) ? <div>{GetText("EventAnswerComplete_HouseholdWaitlistMail")}</div> : null}
      </>;
    }

    if (!isWaitlisted) {
      return GetText("EventAnswerComplete_Description");
    }

    if (!showTimes) {
      return GetText("EventAnswerComplete_WaitlistDescription");
    }

    return <>
      {acceptedTimes.length > 0 ? <div>{GetText("EventAnswerComplete_HasPlace")} {acceptedTimes.join(", ")}</div> : null}
      <div>{GetText("EventAnswerComplete_OnWaitlist")} {waitlistedTimes.join(", ")}</div>
      <div>{GetText("EventAnswerComplete_WaitlistMail")}</div>
    </>;
  };
  const GetText = TextService.GetText;

  return <div id="start" className="NoChromePage" data-testid={isCancelled ? "answer-complete-cancelled" : isOnlyWaitlisted ? "answer-complete-waitlist" : "answer-complete"}>
    <Result
      status={isOnlyWaitlisted || isCancelled ? "info" : "success"}
      title={GetText(isCancelled ? "EventAnswerComplete_CancelledTitle" : isOnlyWaitlisted ? "EventAnswerComplete_WaitlistTitle" : "EventAnswerComplete_Title") + name}
      subTitle={getSubTitle()}
      extra={location.state?.calendarUrl
        ? <Button data-testid="add-to-calendar" icon={<CalendarOutlined />} href={location.state.calendarUrl}>{GetText("EventAnswerComplete_AddToCalendar")}</Button>
        : undefined}
    />
  </div>
};

export default EventAnsweredComplete;